import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-swap.tsx
/**
* icon.24.swap
*
* Keywords: arrows, bidirectional, horizontal, exchange, transfer, opposite, movement, parallel
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTQuNjQ3IDEyLjY0NmEuNS41IDAgMCAxIC43MDcgMGwyLjUgMi41YS41LjUgMCAwIDEgMCAuNzA3bC0yLjUgMi41YS41LjUgMCAwIDEtLjcwNy0uNzA3TDE2LjI5MyAxNkg2LjVhLjUuNSAwIDAgMSAwLTFoOS43OTNsLTEuNjQ2LTEuNjQ2YS41LjUgMCAwIDEgMC0uNzA4bS02LTdhLjUuNSAwIDEgMSAuNzA3LjcwN0w3LjcwNyA4SDE3LjVhLjUuNSAwIDAgMSAwIDFINy43MDdsMS42NDcgMS42NDZhLjUuNSAwIDAgMS0uNzA4LjcwN2wtMi41LTIuNWEuNS41IDAgMCAxIDAtLjcwN3oiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-5704
*/
const Icon24Swap = memo(function Icon24Swap(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M14.647 12.646a.5.5 0 0 1 .707 0l2.5 2.5a.5.5 0 0 1 0 .707l-2.5 2.5a.5.5 0 0 1-.707-.707L16.293 16H6.5a.5.5 0 0 1 0-1h9.793l-1.646-1.646a.5.5 0 0 1 0-.708m-6-7a.5.5 0 1 1 .707.707L7.707 8H17.5a.5.5 0 0 1 0 1H7.707l1.647 1.646a.5.5 0 0 1-.708.707l-2.5-2.5a.5.5 0 0 1 0-.707z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Swap };

//# sourceMappingURL=icon-24-swap.js.map